import { doc, updateDoc, arrayUnion, getFirestore } from 'firebase/firestore';
import Styles from './styles.module.css';
import React from 'react';
import { RxCross2 } from "react-icons/rx";
import JobPostingImage from "../../../../0.functions/JobPostingImage";

type SchoolItemProps = {
  recruitId: string;
  setIsJobPosting: React.Dispatch<React.SetStateAction<any>>;
};

const SchoolJobPostings: React.FC<SchoolItemProps> = ({ recruitId, setIsJobPosting }) => {

  return (
    <>
    <div className={Styles.modal}>
      <div className={Styles.background_black} onClick={() => setIsJobPosting("")}></div>
      <div className={Styles.contents}>
        <div className={Styles.modal_title}>
          <h4>求人票</h4>
          <RxCross2 className={Styles.modal_cross} onClick={() => setIsJobPosting("")} />
        </div>
        <div className={Styles.jobPostings}>
          {/* 年度の優先順(JOB_POSTING_YEARS)に、見つかった求人票を表示する */}
          <JobPostingImage recruitId={recruitId} />
        </div>
        <div className={Styles.save}>
          <button className={Styles.postingsModal_bottom_cancel} onClick={() => setIsJobPosting("")}>閉じる</button>
        </div>
      </div>
    </div>
    </>
  );
}

export default SchoolJobPostings;
